import Cookies from 'js-cookie';

class NativeAppPDF {
  constructor(options = {}) {
    this.config = {
      pdfs: document.querySelectorAll('.c-productdoclist__link'),
      modal: this.createModal(),
      ...options
    };
  }

  init() {
    if (Cookies.get('native')) {
      this.addPdfListeners();
    }
  }

  createModal() {
    console.log(this);
    const modal = document.createElement('div');
    modal.setAttribute('id', 'pdfModal');
    modal.setAttribute('class', 'modal');

    const modalContent = document.createElement('div');
    modalContent.setAttribute('class', 'pdf-modal-content');

    const closeButton = document.createElement('span');
    closeButton.setAttribute('class', 'pdf-modal-close');
    closeButton.innerHTML = '&times;';

    const downloadButton = document.createElement('a');
    downloadButton.setAttribute('id', 'pdfDownloadButton');
    downloadButton.setAttribute('class', 'pdf-download-button');
    downloadButton.innerHTML = 'Download PDF';
    downloadButton.target = '_blank';
    downloadButton.style.display = 'block';
    downloadButton.style.marginBottom = '10px';

    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', 'pdfCanvas');

    modalContent.appendChild(closeButton);
    modalContent.appendChild(downloadButton);
    modalContent.appendChild(canvas);
    modal.appendChild(modalContent);

    document.body.appendChild(modal);

    closeButton.onclick = () => {
      modal.style.display = 'none';
    };

    window.onclick = event => {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    };

    return modal;
  }

  addPdfListeners() {
    this.config.pdfs.forEach(pdf => {
      pdf.addEventListener('click', e => {
        e.preventDefault();
        const pdfLink = pdf.getAttribute('href');
        const downloadButton = document.getElementById('pdfDownloadButton');
        downloadButton.href = pdfLink;

        // Load and render the PDF using PDF.js
        // eslint-disable-next-line no-undef
        const loadingTask = pdfjsLib.getDocument(pdfLink);
        loadingTask.promise.then(pdfItem => {
          // Assuming you want to display only the first page of the PDF
          pdfItem.getPage(1).then(page => {
            const canvas = document.getElementById('pdfCanvas');
            const ctx = canvas.getContext('2d');
            const viewport = page.getViewport({ scale: 1 }); // Adjust scale as needed
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
              canvasContext: ctx,
              viewport
            };
            page.render(renderContext);
          });
        });

        this.config.modal.style.display = 'block';
      });
    });
  }
}

export default NativeAppPDF;
